<template>
  
    <content-header
        icona="fas fa-tachometer-alt"
        titolo="Bacheca"
    ></content-header>

    
    <div class="card sn-card-contenuto">
        <div class="card-body">

            <div class="d-flex mb-4">
                <div class="card me-2" style="width: 100%;">
                   <div class="card-header">
                        Richieste attivazione corsi
                   </div>
                   <div class="card-body">
                        <!-- **** GRIGLIA CORSI PRENOTATI **** -->
                        <table class="table table-sm table-custom">
                            <thead>
                                <tr>
                                    <th>Id. pren.</th>
                                    <th>Corso</th>
                                    <th>Cliente</th>
                                    <th>Data Prenotazione</th>
                                    <th>Part. rich./iscr.</th>
                                    <th>Stato</th>
                                    <th>Note</th>
                                    <th><i class="fas fa-bars"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="p, i in dtCorsiPrenotazioni" :key="i">
                                    <td>{{ p.cpr_id }}</td>
                                    <td>{{ p.cct_titolo }}</td>
                                    <td>{{ p.ana_ragioneSociale }}</td>
                                    <td>{{ FormattaData(p.cpr_dtaPrenota) }}</td>
                                    <td>{{ p.cpr_npartecipanti }} / 
                                        <span v-if="p.partecIscritti == p.cpr_npartecipanti" >{{ p.partecIscritti }}</span>
                                        <span v-else style="color: red;">{{ p.partecIscritti }}</span>
                                    </td>
                                    <td>{{ p.cps_descrizione }}</td>
                                    <td>{{ p.cpr_note }}</td>
                                    <td>
                                        <router-link :to="{ path: '/catalogo', query: { idCat: p.cpr_idCct} }">
                                            <i class="fas fa-chevron-right"></i>
                                        </router-link>
                                    </td>
                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


            <div class="d-flex mb-4">
                <div class="card me-2" style="width: 100%;">
                    <div class="card-header">
                        Calendario mensile corsi
                    </div>
                    <div class="card-body">

                        <!-- *** NAVIGAZIONE CALENDARIO*** -->
                        <div class="d-flex justify-content-start mb-2">
                            <div class="px-1"><button type="button" class="btn btn-sm btn-outline-primary" @click="Precedente">Prec.</button></div>
                            <div class="px-1">
                                <select class="form-control form-control-sm" v-model="meseSelezionato">
                                    <option value="1">gennaio</option>
                                    <option value="2">febbraio</option>
                                    <option value="3">marzo</option>
                                    <option value="4">aprile</option>
                                    <option value="5">maggio</option>
                                    <option value="6">giugno</option>
                                    <option value="7">luglio</option>
                                    <option value="8">agosto</option>
                                    <option value="9">settembre</option>
                                    <option value="10">ottobre</option>
                                    <option value="11">novembre</option>
                                    <option value="12">dicembre</option>
                                </select>
                            </div>
                            <div class="px-1">
                                <select class="form-control form-control-sm" v-model="annoSelezionato" @change="CambiaAnno">
                                    <option v-for="a, i in AnniPrecedenti" :key="i" :value="a">{{a}}</option>
                                    <option :value="annoSelezionato" selected>{{annoSelezionato}}</option>
                                    <option v-for="a, i in AnniSuccessivi" :key="i" :value="a">{{a}}</option>
                                </select>
                            </div>
                            <div class="px-1">
                                <button type="button" class="btn btn-sm btn-outline-primary" @click="AzzeraData">
                                <i class="fas fa-calendar-check"></i>
                                </button>
                            </div>
                            <div class="px-1"><button type="button" class="btn btn-sm btn-outline-primary" @click="Successivo">Succ.</button></div>
                            
                        </div>


                        <!-- *** CALENDARIO *** -->
                        <table class="tbCalendario">
                        <thead>
                            <tr>
                                <th v-for="d, i in GiorniMeseSelezionato" :key="i"><span :class="{'text-danger': d.nomeGiorno == 'Dom'}">{{d.nomeGiorno}} <br />{{ d.giorno }}</span></th>
                            </tr>
                        </thead> 
                        <tbody>
                            <tr>
                                <td v-for="d, i in GiorniMeseSelezionato" :key="i" :class="{'tdBorder': d.nomeGiorno == 'Dom'}">
                                    <template v-for="c, ic in dtCorsi" :key="ic">

                                        <!-- *** Card corso *** -->
                                        <div class="card cardCalendario mb-2" v-if="d.giorno == parseInt(c.cor_dta_inizio.substring(0,2), 10)">
                                            <div class="card-header">
                                                <i class="fas fa-certificate fa-sm fa-fw text-danger" v-if="c.cor_idTipo == 1" title="Profitto"></i>
                                                <i class="fas fa-handshake fa-sm fa-fw text-info" v-else title="Partecipazione"></i>
                                                &nbsp;{{ c.cor_titolo }}
                                            </div>
                                            <div class="card-body">
                                                <p>dal {{ c.cor_dta_inizio }} al {{ c.cor_dta_fine }}</p>
                                                <p>Partecipanti: {{ c.npartecipanti }}/{{ c.cor_npartecipanti_max }}</p>

                                                <router-link :to="'/corsi?edit=' + c.cor_id">
                                                    <i class="fas fa-edit fa-sm text-primary"></i>
                                                </router-link>

                                            </div>
                                        </div>

                                    </template>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                        <small>** la data di riferimento è la data di inizio corso</small>


                            



                        
                    </div>
                </div>
            </div>


            


        </div>
    </div>
    
</template>

<script>
import ContentHeader from '@/components/layout/ContentHeader.vue';
import snFunctions from '@/lib/snFunctions.js';

export default {
    name: 'DashboardView',
    components: {
        ContentHeader
    },
    inject: ['cfg'],
    data: function () {
        return {
            dtCorsi: [],
            dtCorsiPrenotazioni: [],

            meseSelezionato: new Date().getMonth() + 1,
            annoSelezionato: new Date().getFullYear(),

        }
    },
    methods: {
        // Carica i corsi del mese corrente
        GetListCorsi() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Corsi/GetListCorsi?token=" + this.$store.state.UserInfo.token + '&anno=' + this.annoSelezionato + '&mese=' + this.meseSelezionato)
                .then(response => response.json())
                .then(obj => {
                    this.dtCorsi = obj;
                });
        },
        // Carica prenotazioni attive
        GetListCorsiPrenotazioni(idCct) {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/GetListCorsiPrenotazioniPending?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtCorsiPrenotazioni = obj;
                });
        },


        //Controlli selettore data
        AzzeraData() {
            this.meseSelezionato = new Date().getMonth() + 1;
            this.annoSelezionato = new Date().getFullYear();
            this.GetListCorsi();
        },
        Precedente() {
            if(this.meseSelezionato > 1) this.meseSelezionato--;
            if(this.meseSelezionato == 1) {
                this.meseSelezionato = 12;
                this.annoSelezionato--;
            }
            this.GetListCorsi();
        },
        Successivo() {
            if(this.meseSelezionato < 12) this.meseSelezionato++;
            if(this.meseSelezionato == 12) {
                this.meseSelezionato = 1;
                this.annoSelezionato++;
            }
            this.GetListCorsi();
        },
        CambiaAnno() {
            this.GetListCorsi();
        },
        GiorniSettimana(giorno) {
            let gname = "";
            if(giorno == 0) gname = "Dom"; 
            if(giorno == 1) gname = "Lun";
            if(giorno == 2) gname = "Mar";
            if(giorno == 3) gname = "Mer";
            if(giorno == 4) gname = "Gio";
            if(giorno == 5) gname = "Ven";
            if(giorno == 6) gname = "Sab";

            return gname;
        },

        /* *** ALTRE FUNZIONI *** */
        FormattaData(dta) {
            return snFunctions.dateFormat(dta, "dd-MM-yyyy");
        },
    
    },
    computed: {
        AnniPrecedenti() {
            let anno = this.annoSelezionato;
            let annip = [];
            for(let ap = anno -5; ap < anno; ap++) {
                annip.push(ap);
            }
            return annip;
        },
        AnniSuccessivi() {
            let anno = this.annoSelezionato;
            let annis = [];
            for(let as = 1; as <= 5; as++) {
                annis.push(anno + as);
            }
            return annis;
        },
        MeseCorrente() {
            return new Date().getMonth() + 1;
        },
        GiorniMeseSelezionato() {
            let dtGiorni = [];
            let aGiorni = new Date(this.annoSelezionato, this.meseSelezionato, 0).getDate(); //torna array con giorni
            for(let i = 1; i<= aGiorni; i++) {
                let gds = new Date(this.annoSelezionato, this.meseSelezionato -1, i).getDay();
                dtGiorni.push({
                    giorno: i,
                    nomeGiorno: this.GiorniSettimana(gds)
                })
            }

            return dtGiorni;
        },
        

    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.GetListCorsi();
        this.GetListCorsiPrenotazioni();
    }
}
</script>

<style>


table.tbCalendario {
  width:100%;
}

table.tbCalendario th {
  background-color: #000;
  color:#fff;
  padding:3px;
  text-align:center;
  border:solid 1px #fff;
}
table.tbCalendario td {
  height: 250px;
  overflow: auto;
  background-color:#faf5c7;
  
  padding-top:10px;
  padding-bottom:10px;
  
}

table.tbCalendario td.tdBorder {
  border-left: solid 1px #ccc;
  border-right: solid 1px #ccc;
  
}

div.cardCalendario > div.card-header {
  color:#CC3731;
  padding:4px;
  font-size: 12px;
}

div.cardCalendario > div.card-body {
  padding:6px;
  font-size: 11px;
}

</style>